export type MarketSymbol = 'BTC' | 'ETH' | 'SOL'

export interface MarketAssetDefinition {
  readonly symbol: MarketSymbol
  readonly name: string
  readonly startingPrice: number
  readonly volatility: number
  readonly color: string
}

export const MARKET_ASSETS: Record<MarketSymbol, MarketAssetDefinition> = {
  BTC: { symbol: 'BTC', name: 'Bitcoin', startingPrice: 64_230, volatility: 0.0028, color: '#f3a446' },
  ETH: { symbol: 'ETH', name: 'Ethereum', startingPrice: 3_248, volatility: 0.0042, color: '#8b73ff' },
  SOL: { symbol: 'SOL', name: 'Solana', startingPrice: 142, volatility: 0.0065, color: '#37e2ae' },
}

export const MARKET_SYMBOLS = Object.keys(MARKET_ASSETS) as MarketSymbol[]

export interface MarketEventDefinition {
  readonly headline: string
  readonly detail: string
  readonly asset: MarketSymbol | 'ALL'
  readonly drift: number
  readonly gasImpact: number
  readonly tone: 'positive' | 'negative' | 'neutral'
}

export const MARKET_EVENTS: readonly MarketEventDefinition[] = [
  { headline: 'INSTITUTIONAL BUYING', detail: 'BTC demand accelerating', asset: 'BTC', drift: 0.0045, gasImpact: 1, tone: 'positive' },
  { headline: 'VALIDATOR UPGRADE', detail: 'ETH network confidence rising', asset: 'ETH', drift: 0.0055, gasImpact: 5, tone: 'positive' },
  { headline: 'SOL MOMENTUM', detail: 'High-throughput rotation detected', asset: 'SOL', drift: 0.008, gasImpact: 0, tone: 'positive' },
  { headline: 'LIQUIDATION CASCADE', detail: 'Risk assets under pressure', asset: 'ALL', drift: -0.0065, gasImpact: 9, tone: 'negative' },
  { headline: 'NETWORK CONGESTION', detail: 'Gas market volatility elevated', asset: 'ETH', drift: -0.003, gasImpact: 18, tone: 'negative' },
  { headline: 'RISK-ON ROTATION', detail: 'Capital moving across the market', asset: 'ALL', drift: 0.0028, gasImpact: 2, tone: 'positive' },
] as const
